

import { IconWrapper } from "../icon-wrapper";
import type { ISvgIcons } from "../type";

export function LabelFilledIcon({
  color = "currentColor",
  ...rest
}: ISvgIcons) {
  return (
    <IconWrapper color={color} {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.884559 1.75908C1.07631 1.38275 1.38227 1.07679 1.75859 0.885047C2.01084 0.756518 2.27299 0.708974 2.53655 0.68744C2.78627 0.667037 3.08945 0.667048 3.44088 0.66706L6.50513 0.667026C6.77639 0.666773 7.01555 0.666551 7.24784 0.72232C7.45191 0.771314 7.647 0.852122 7.82595 0.96178C8.02964 1.0866 8.1986 1.25588 8.39023 1.44787L13.5614 6.61904C13.9408 6.9985 14.254 7.31168 14.4883 7.58765C14.7316 7.87428 14.9287 8.16432 15.041 8.50968C15.215 9.04526 15.215 9.62219 15.041 10.1578C14.9287 10.5031 14.7316 10.7932 14.4883 11.0798C14.254 11.3558 13.9408 11.6689 13.5614 12.0484L12.0479 13.5619C11.6685 13.9413 11.3553 14.2545 11.0793 14.4888C10.7927 14.7321 10.5026 14.9292 10.1573 15.0414C9.6217 15.2155 9.04477 15.2155 8.50919 15.0414C8.16383 14.9292 7.87379 14.7321 7.58716 14.4888C7.3112 14.2545 6.99802 13.9413 6.61856 13.5619L1.44738 8.39072C1.25539 8.19909 1.08611 8.03013 0.961291 7.82644C0.851634 7.64749 0.770825 7.4524 0.721832 7.24833C0.666062 7.01603 0.666285 6.77687 0.666537 6.5056L0.666571 3.44136C0.666559 3.08993 0.666549 2.78676 0.686952 2.53704C0.708486 2.27348 0.75603 2.01133 0.884559 1.75908ZM5.33325 4.00033C4.59687 4.00033 3.99992 4.59728 3.99992 5.33366C3.99992 6.07004 4.59687 6.66699 5.33325 6.66699C6.06963 6.66699 6.66658 6.07004 6.66658 5.33366C6.66658 4.59728 6.06963 4.00033 5.33325 4.00033Z"
        fill={color}
      />
    </IconWrapper>
  );
}
